module.exports = __webpack_public_path__ + "img/demand.9bb84e4e.svg";